import { Component, inject, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { HomeNavigationService } from "navigation/list/home.navigation.service";
import { Observable } from "rxjs";
import { PageHeaderComponent } from "common/page/page-header.component";
import { EntryPagesComponent } from "./description/entry-pages.component";
import { AsyncPipe, NgClass } from "@angular/common";
import { MyMostFrequentlyUsedElementsComponent } from "./myMostFrequentlyUsedElements/my-most-frequently-used-elements.component";
import { ToDoListComponent } from "./to-do-list/to-do-list.component";
import { RecentlyUsedFilesComponent } from "./recentlyUsedFiles/recently-used-files.component";
import { SupportComponent } from "./support.component";
import { map } from "rxjs/operators";
import { LayoutService, Size } from "core/layout.service";

@Component({
	selector: "stages-dashboard",
	templateUrl: "./dashboard.component.html",
	providers: [
		{
			provide: "title",
			useFactory: DashboardComponent.provideTitle,
			deps: [TranslateService, "mergedRouteData"],
		},
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [
		PageHeaderComponent,
		EntryPagesComponent,
		NgClass,
		MyMostFrequentlyUsedElementsComponent,
		ToDoListComponent,
		RecentlyUsedFilesComponent,
		SupportComponent,
		AsyncPipe,
	],
})
export class DashboardComponent implements OnInit {
	private homeNavigationService = inject(HomeNavigationService);
	private layoutService = inject(LayoutService);

	size$: Observable<Size>;

	constructor() {
		this.size$ = this.layoutService.size.asObservable();
	}

	ngOnInit(): void {
		this.homeNavigationService.update();
	}

	// eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Remove this comment and fix warnings!
	static provideTitle(translateService: TranslateService, mergedRouteData: any): Observable<string> {
		return translateService
			.get("navigation.drawer.home")
			.pipe(map((title) => `${title} - ${mergedRouteData.workspaceView.currentWorkspace.name}`));
	}

	isSmallScreen(size: Size): boolean {
		return size === Size.XXSMALL;
	}

	isMediumScreen(size: Size): boolean {
		switch (size) {
			case Size.XSMALL: {
				return true;
			}
			case Size.SMALL: {
				return true;
			}
			case Size.MEDIUM: {
				return true;
			}
			default: {
				return false;
			}
		}
	}

	isLargeScreen(size: Size): boolean {
		switch (size) {
			case Size.XLARGE: {
				return true;
			}
			case Size.LARGE: {
				return true;
			}
			default: {
				return false;
			}
		}
	}

	protected readonly Size = Size;
}
